export default __webpack_public_path__ + "static/media/zerion.ba2bdce0.svg";